import React, { useState, useCallback, useEffect } from 'react';
import moment from 'moment';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../../providers/AuthProvider';
import hdBonusService from '../../services/hd.bonus.service';
import BonusHistoryTable from '../../components/HDBonus/BonusHistoryTable';
import QuarterlyBonusSummary from '../../components/HDBonus/QuarterlyBonusSummary';
import HDBonusForm from '../../components/Bonuses/HDBonusForm';

const HDBonus = () => {
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [hasSubmittedThisMonth, setHasSubmittedThisMonth] = useState(false);
  const [submissionDate, setSubmissionDate] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Use the auth hook for checking logged in state only
  const { isCheckingLoggedState } = useAuth();

  // Check for existing submission when the page loads
  useEffect(() => {
    const checkExistingSubmission = async () => {
      try {
        const { data } = await hdBonusService.CheckExistingSubmission(moment().format('YYYY-MM'));

        if (data.hasSubmitted && data.submission) {
          setHasSubmittedThisMonth(true);
          setSubmitSuccess(true);
          setSubmissionDate(moment(data.submission.submissionDate).format('MMM D, YYYY'));
        }
      } catch (error) {
        console.error('Error checking existing submission:', error);
      }
    };

    if (!isCheckingLoggedState) {
      checkExistingSubmission();
    }
  }, [isCheckingLoggedState]);

  // Handle successful form submission
  const handleSubmissionSuccess = useCallback(() => {
    setSubmitSuccess(true);
    setHasSubmittedThisMonth(true);
    setSubmissionDate(moment().format('MMM D, YYYY'));
    setRefreshTrigger((prev) => prev + 1);
  }, []);

  // Don't render while checking authentication
  if (isCheckingLoggedState) return null;

  return (
    <div className="container py-4">
      <h1 className="mb-4">Health & Development Bonus</h1>

      {/* Quarterly Bonus Summary */}
      <QuarterlyBonusSummary refreshTrigger={refreshTrigger} />

      {/* Bonus History Section */}
      <BonusHistoryTable refreshTrigger={refreshTrigger} />

      {/* Bonus Submission Form */}
      <Card>
        <Card.Header as="h5">Log Your Monthly Bonus</Card.Header>
        <Card.Body>
          {hasSubmittedThisMonth ? (
            <Alert variant="success">
              Health and Development Bonus Submitted on {submissionDate || moment().format('MMM D, YYYY')}
            </Alert>
          ) : submitSuccess ? (
            <Alert variant="success">
              Health and Development Bonus Submitted on {submissionDate || moment().format('MMM D, YYYY')}
            </Alert>
          ) : (
            <HDBonusForm onSubmissionSuccess={handleSubmissionSuccess} />
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default HDBonus;
